import React from 'react';
import Error from 'next/error';

import { getBlogArticles, getBlogArticleBySlug } from '../src/lib/backend';
import BlogArticlesPage from '../src/components/blog/BlogArticlesPage';
import BlogArticlePage from '../src/components/blog/BlogArticlePage';
import { getArticlesPage } from '../src/selectors/articles';
import R from '../src/lib/routes';

const blogPage = ({ single, data, error, ...passProps }) => {
  if (error) {
    return <Error statusCode={error.code} />;
  }
  return single ? (
    <BlogArticlePage {...data} {...passProps} />
  ) : (
    <BlogArticlesPage {...data} {...passProps} />
  );
};

blogPage.getInitialProps = async ({ query, session }) => {
  try {
    const slug = query && query.slug;

    if (slug) {
      // Load one article
      const data = await getBlogArticleBySlug(session, slug);
      return {
        single: true,
        data,
      };
    }

    // Load paginated list of articles
    const page = getArticlesPage(R.blog);
    const result = await getBlogArticles(session, page);

    return {
      single: false,
      data: {
        articles: result.items,
        page: result.page,
        totalPages: result.totalPages,
      },
    };
  } catch (error) {
    console.error('Failed to load blog', error);
    return { error };
  }
};

export default blogPage;
